module.exports = __webpack_public_path__ + "resources/icon-official.753ddc29157fc9f8.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/comment-item/img/icon-official.png
// module id = 713
// module chunks = 0 1 2